import { MESSAGES } from '@/constants/messages';
import { useApproveExternalAccount } from '@/hooks/requests/useExternalAccounts';
import { ExternalAccountActionButtonProps } from '@/types/externalAccounts';
import showToast from '@/utils/toast';
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  DialogActions,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { useState } from 'react';
import { SVButton, SVForm, SVCheckbox } from '@/components/core';

export default function ExternalAccountApproveButton({
  id,
}: ExternalAccountActionButtonProps) {
  const [open, setOpen] = useState(false);
  const { approveExternalAccount, isApproveExternalAccountPending } =
    useApproveExternalAccount();
  const formMethods = useForm({
    defaultValues: {
      complianceCheck: false,
    },
  });

  async function handleConfirm() {
    try {
      await approveExternalAccount(id);
      showToast({
        type: 'success',
        data: { content: 'The external account has been approved' },
      });
    } catch {
      showToast({ type: 'error', data: { content: MESSAGES.genericError } });
    }
  }

  return (
    <>
      <SVButton onClick={() => setOpen(true)} fullWidth variant="success">
        Approve
      </SVButton>
      <Dialog fullWidth open={open} onClose={() => setOpen(false)}>
        <SVForm methods={formMethods} onSubmit={handleConfirm}>
          <DialogContent>
            <Box>
              <Typography variant="h6" component="h2">
                Approve External Account
              </Typography>
              <Typography sx={{ mt: 2 }}>
                Are you sure you want to approve this linked account?
              </Typography>
              <SVCheckbox
                name="complianceCheck"
                label="I have followed all compliance guidelines for ensuring that the customer is linking a first party account for which they are an owner and that the customer has agreed to link the account"
              />
            </Box>
          </DialogContent>
          <DialogActions>
            <SVButton onClick={() => setOpen(false)} variant="tertiary">
              No, Don't Approve
            </SVButton>
            <SVButton type="submit" isLoading={isApproveExternalAccountPending}>
              Yes, Approve This External Account
            </SVButton>
          </DialogActions>
        </SVForm>
      </Dialog>
    </>
  );
}
